import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
  },
  contentWrapper: {
    paddingTop: 20,
    paddingHorizontal: 40,
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    textAlign: 'left',
  },
  exhibitionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    width: '100%',
  },
  exhibitionItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    width: '100%',
    height: 42,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    height: 42,
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    border: '1px solid #EDEDED',
    borderRadius: 4,

    width: 85,
    height: 42,
  },
  companyLogo: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    borderRadius: 4,
  },
  titleWrapper: {
    flex: 1,
    justifyContent: 'center',
  },
  aboutText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 400,
  },
  websiteURLText: {
    color: '#27343d',
    fontSize: 6,
    fontFamily: 'Lato',
    fontWeight: 900,
  },
});
